import { render, staticRenderFns } from "./manual.vue?vue&type=template&id=d0273e04&scoped=true&"
import script from "./manual.vue?vue&type=script&lang=js&"
export * from "./manual.vue?vue&type=script&lang=js&"
import style0 from "./manual.vue?vue&type=style&index=0&id=d0273e04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0273e04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0273e04')) {
      api.createRecord('d0273e04', component.options)
    } else {
      api.reload('d0273e04', component.options)
    }
    module.hot.accept("./manual.vue?vue&type=template&id=d0273e04&scoped=true&", function () {
      api.rerender('d0273e04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/social/manual.vue"
export default component.exports